const ROOT_TITLES: Record<string, string> = {
  catalog: 'Software catalog',
  documentation: 'Documentation',
  'api-docs': 'API Explorer',
  announcements: 'Announcements',
  feedback: 'Feedback',
  incidents: 'Incidents',
  search: 'Search',
  settings: 'Settings',
};

/** Entity and TechDocs reader pages (`/<root>/<ns>/<kind>/<name>`) set their own title. */
const OWN_TITLE_DEPTH = 4;

/**
 * The tab title for a route that sets none itself, or undefined when the page
 * owns its title.
 */
export function routeTitle(pathname: string): string | undefined {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) return 'Home';
  if (
    (segments[0] === 'catalog' || segments[0] === 'documentation') &&
    segments.length >= OWN_TITLE_DEPTH
  ) {
    return undefined;
  }
  return ROOT_TITLES[segments[0]];
}
